import { IconButton, Typography } from "@mui/material";
import { styled } from "@mui/system";

export const ChevronButton = styled(IconButton)(({ theme }) => ({
  cursor: "pointer",
  padding: "5px",
  borderRadius: "50%",
  "&:hover": {
    backgroundColor: theme.palette.gray20.main,
  },
}));

export const StyledIcon = styled("span")(({ theme }) => ({
  color: theme.palette.gray80.main,
  width: "24px",
  height: "24px",
}));

export const StyledText = styled(Typography)(({ theme }) => ({
  color: theme.palette.gray80.main,
  paddingLeft: "19px",
}));
